import { Injectable } from '@angular/core';
import MenuStructure from '@assets/docs/menu-structure.json';
import { SubNav } from '@core/models/sub-nav.model';
import * as _ from 'lodash-es';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SubNavService {

  private subNavOut = new BehaviorSubject<SubNav[]>([]);
  getSubNavOut = this.subNavOut.asObservable();

  private getSubNav(baseRoute: string): SubNav[] {
    if (baseRoute) {
      let subNav = null;
      MenuStructure.menu.forEach(element => {
        if (element.name === baseRoute && subNav === null) {
          subNav = _.cloneDeep(<SubNav[]>element.sub);
        }
      });
      return subNav;
    }
    return null;
  }

  getFormatedSubNav(routes: string[]): void {
    let subNav = [];
    if (routes.length > 1) {
      if (routes.length === 2) {
        subNav = this.getSubNav(routes[1]);
        if (subNav) {
          subNav.forEach(element => {
            if (element.default) {
              element.selected = true;
            }
          });
        }
      } else {
        subNav = this.getSubNav(routes[1]);
        if (routes[2] && subNav) {
          subNav.forEach(nav => {
            nav.paths.forEach(path => {
              if (path.path === routes[2]) {
                nav.selected = true;
              }
            });
          });
        }
      }
    }
    this.subNavOut.next(subNav);
  }
}
